import styled from 'styled-components'
import { breakpoints } from '../../../MediasQueries'
export const Select = styled.select`
  -webkit-border-radius: 3px;
  text-transform: lowercase;
  width: 100%;
  border: 1px solid rgb(206, 212, 218);
  display: flex;
  color: ${({ theme }) => theme.primary};
  padding: 0px 1vh;
  outline: none;
  height: 30px;
  @media (max-width: ${breakpoints.sm}) {
    height: 35px;
  }
  &:disabled {
    background: rgba(0, 0, 0, 0.1);
    opacity: 1;
  }
`
export const Item = styled.div`
  display: flex;
  flex-direction: column;
  label {
    font-size: 12px;
  }
`
